<div *ngIf="tableData" class="detail-table-container">
    <div class="detail-table-header">
        <div>
            <div class="mat-body-1 m-0">{{ tableData.title }}</div>
            <div *ngIf="tableData?.subtitle" class="mat-body-2 text-hint m-0" style="white-space: pre-wrap">{{ tableData?.subtitle }}</div>
        </div>

        <div></div>
    </div>
    <table>
        <ng-container *ngFor="let content of tableData.tableContents">
            <tr>
                <th class="mat-body-2 m-0" [class.bold-text]="content.isHighlighted">{{ content.name }}</th>
                <td class="mat-subtitle-2 m-0" [class.bold-text]="content.isHighlighted">
                    <div
                        *ngIf="content.status; else textValueTemp"
                        style="margin: 0px !important; min-width: 150px !important"
                        [class]="'text-badge ' + content.status.class"
                    >
                        <div class="mat-caption m-0">{{ content.status.value | uppercase }}</div>
                    </div>

                    <ng-template #textValueTemp>
                        <span *ngIf="!content.url && !content.fileName && !content.fileType" [class.bold-text]="content.isHighlighted">{{ content.value }}</span>
                        <a
                            *ngIf="content.url && content.fileName && content.fileType && !content.attachmentUrl"
                            [href]="content.url"
                            [attr.download]="content.value"
                            (click)="onDownload(content.fileName, content.fileType, content.fileSize)"
                            class="mat-subtitle-2 secondary-text"
                            style="text-decoration: underline"
                        >
                            {{ content.value }}
                        </a>
                        <a
                            *ngIf="content.url && content.fileName && content.fileType && content.attachmentUrl"
                            [attr.download]="content.value"
                            (click)="onDownload(content.fileName, content.fileType, content.fileSize, content.attachmentUrl)"
                            class="mat-subtitle-2 secondary-text"
                            style="text-decoration: underline"
                        >
                            {{ content.value }}
                        </a>
                    </ng-template>
                </td>
            </tr>
        </ng-container>
    </table>
</div>
